import { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';

import Grid from '@mui/material/Grid';

import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';

import TicketStatus from './TicketsStatus';

const TicketInfo = (props) => {
  const { ticketId } = props || {};

  const [ticketStatus, setTicketStatus] = useState();

  const params = useParams();

  useEffect(() => {
    setTicketStatus(params.ticketId);
  }, [params]);

  return (
    <Grid container className='ticket-id-status'>
      <Grid item size={{ xs: 6 }}>
        <h2>
          <ConfirmationNumberIcon className='svg' /> {ticketId}
        </h2>
      </Grid>
      <Grid item size={{ xs: 6 }}>
        <TicketStatus ticketId={ticketStatus} />
      </Grid>
    </Grid>
  );
};

export default TicketInfo;
